import {normalizeRpcAccount} from './getAccountInfo.js';
import {getLimiter} from './../instance.js';
export async function fetchAccountInfo(mint: string) {
  const method = "getAccountInfo";
  const params = [mint, { encoding: "jsonParsed" }];
  return getLimiter().fetchRpc(method, params);
}
export async function fetchAndNormalizeAccountInfo(mint: string) {
  const rpc = await fetchAccountInfo(mint);
  return normalizeRpcAccount(mint, rpc.result);
}

